import { useCallback } from 'react'
import { useIntl } from 'react-intl'

import { useAjaxContext } from '../../../core/ajax'
import { feedback } from '../../../core/feedback'

const ERR_CODE_NOT_CONFIRMED = 3503

export const useLoginCalls = () => {
  const { login, postPublic, revokeToken } = useAjaxContext()
  const { formatMessage } = useIntl()

  const noResponseError = () =>
    feedback('error', formatMessage({ id: 'calls.responseless.error.description' }))
  const defaultError = () => {}

  const loginCall = useCallback(
    (payload) =>
      new Promise((resolve, reject) => {
        login(payload)
          .then((response) => {
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 400:
                if (response.data.code === ERR_CODE_NOT_CONFIRMED) {
                  return reject('inactive_user')
                }
                break
              default:
                defaultError()
            }
            return reject(response)
          })
      }),
    [login, noResponseError, formatMessage]
  )

  const resendValidation = useCallback(
    (mail) =>
      new Promise((resolve, reject) => {
        postPublic(`/usuario/resend_mail/${mail}`, { area: 'cliente' })
          .then((response) => {
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              default:
                defaultError()
            }
            return reject(response.status)
          })
      }),
    [postPublic, noResponseError]
  )

  const revokeTokenCall = useCallback(
    (authData) =>
      new Promise((resolve, reject) => {
        revokeToken(authData)
          .then((response) => {
            feedback('success', formatMessage({ id: 'calls.revoke.success.description' }))
            resolve(response)
          })
          .catch(({ response }) => {
            if (!response) {
              noResponseError()
              return reject('No response')
            }
            switch (response.status) {
              case 401:
              case 400:
                feedback('warning', formatMessage({ id: 'calls.revoke.unauthorized.description' }))
                break
              default:
                defaultError()
            }
            return reject(response)
          })
      }),
    [] // eslint-disable-line
  )

  return {
    loginCall,
    resendValidation,
    revokeTokenCall,
  }
}
